module.exports = __webpack_public_path__ + "images/feature/0707_doc_code_2-a5e03f8853051422ffc8c351570f4ab0.jpg";